@if (appSettings.isMobile() && visible()) {
  <div class="mobile-footer-bar">
    <ng-content></ng-content>
  </div>
}
